var _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconBFile(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    xmlnsserif: "http://www.serif.com/",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    id: "iconB-file",
    x: 0,
    y: 0,
    width: 24,
    height: 23.983,
    style: {
      fill: "none"
    }
  }), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "iconB-file1",
    serifid: "iconB-file"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    d: "M14.396,1.351c0.011,0.005 0.023,0.01 0.034,0.016c0.143,0.066 0.283,0.14 0.417,0.222c0.352,0.216 0.663,0.507 1.266,1.11l3.188,3.188c0.603,0.603 0.894,0.914 1.11,1.266c0.083,0.135 0.157,0.275 0.223,0.419c0.005,0.01 0.01,0.02 0.014,0.03c0.102,0.227 0.183,0.464 0.241,0.707c0.097,0.401 0.111,0.827 0.111,1.679l0,7.212c0,1.925 -0.061,2.881 -0.436,3.616c-0.383,0.753 -0.995,1.365 -1.748,1.748c-0.735,0.375 -1.691,0.436 -3.616,0.436l-6.4,-0c-1.925,-0 -2.881,-0.061 -3.616,-0.436c-0.753,-0.383 -1.365,-0.995 -1.748,-1.748c-0.375,-0.735 -0.436,-1.691 -0.436,-3.616l0,-10.4c0,-1.925 0.061,-2.881 0.436,-3.616c0.383,-0.753 0.995,-1.365 1.748,-1.748c0.735,-0.375 1.691,-0.436 3.616,-0.436l3.212,-0c0.852,-0 1.278,0.014 1.679,0.111c0.242,0.058 0.478,0.138 0.705,0.24Zm4.587,7.649l-3.383,-0c-0.805,-0 -1.2,-0.061 -1.508,-0.218c-0.376,-0.192 -0.682,-0.498 -0.874,-0.874c-0.157,-0.308 -0.218,-0.703 -0.218,-1.508l-0,-3.4l-4.2,-0c-1.436,-0 -2.16,-0.061 -2.708,0.218c-0.376,0.192 -0.682,0.498 -0.874,0.874c-0.279,0.548 -0.218,1.272 -0.218,2.708l0,10.4c0,1.436 -0.061,2.159 0.218,2.708c0.192,0.376 0.498,0.682 0.874,0.874c0.548,0.279 1.272,0.218 2.708,0.218l6.4,0c1.436,0 2.16,0.061 2.708,-0.218c0.376,-0.192 0.682,-0.498 0.874,-0.874c0.279,-0.548 0.218,-1.272 0.218,-2.708l0,-7.212c0,-0.461 0.008,-0.75 -0.017,-0.988Zm-3.983,-4.586c0,0 0.01,2.46 0.016,2.57c0.11,0.006 2.57,0.016 2.57,0.016l-2.586,-2.586Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconBFile);
export default __webpack_public_path__ + "static/media/iconB-file.c31849b4152549aedfd95858045c607e.svg";
export { ForwardRef as ReactComponent };